import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private apiUrl = environment.apiUrl;
  private apiStoreUrl = environment.apiStoreUrl;

  private auth = new BehaviorSubject<boolean>(false);
  public authState = this.auth.asObservable();

  private currentUserSubject = new BehaviorSubject<any>(null);
  public currentUser = this.currentUserSubject.asObservable();

  constructor(private http: HttpClient) {
    const token = this.getToken();
    if (token) {
      this.auth.next(true);
      const user = this.getUserDetails();
      if (user) {
        this.currentUserSubject.next(user);
      }
    }
  }

  updateUser(authState: boolean, user: any): void {
    this.auth.next(authState);
    this.currentUserSubject.next({ ...user });
  }

  login(credentials: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/admin/login`, credentials);
  }

  sendOTP(mobileObj: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/admin/send-otp`, mobileObj);
  }

  verifyOTP(otpObj: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/admin/login-otp`, otpObj);
  }

  setPassword(pwdObj: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/admin/set-password`, pwdObj);
  }

  changePassword(pwdObj: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/admin/change-password`, pwdObj);
  }
  logout(): Observable<any> {
    return this.http.post(`${this.apiUrl}/admin/logout`, {});
  }

  getProfile(): Observable<any> {
    return this.http.get(`${this.apiStoreUrl}/admin/profile`);
  }

  setToken(token: string): void {
    localStorage.setItem('token', token);
  }

  getToken(): string | null {
    return localStorage.getItem('token');
  }

  removeTokens(): void {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  }

  setUserDetails(user: any): void {
    localStorage.setItem('user', JSON.stringify(user));
    if (user) {
      this.updateUser(true, user);
    } else {
      this.updateUser(false, null);
    }
  }

  getUserDetails(): any {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  }

  isLoggedIn(): boolean {
    return !!this.getToken();
  }
}